import React, { Fragment } from 'react';
import Head from 'next/head';
import { observer } from 'mobx-react';
import { Disclosure, Menu, Transition } from '@headlessui/react';
import { MailIcon, PhoneIcon, ChevronDownIcon } from '@heroicons/react/outline';
import { makeObservable } from 'mobx';
import 'tailwindcss/tailwind.css';
import { memoize } from '../../utils/mobx/decorators/memoize';
import { Store } from '../../pagepart/store/Store';
import { StoreContext } from 'src/pagepart/utils';
import { Env } from '../../env/Env';
import { ServerProps } from '../../pagepart/portal/utils';
import { TopbarNavigationDropdown } from '../../tailwind/info/TopbarNavigationDropdown';
import { InfoTopbar } from '../../tailwind/info/InfoTopbar';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export async function getServerSideProps(rawContext) {
  const { env, userEnv, requestEnv } = await Env.forNextContext(rawContext);

  return {
    props: {
      ...env.transfer,
    },
  };
}

const agbs = [
  {
    question: 'Kosten',
    answer: (
      <div>
        Das Angebot bei schlaukopf.de ist kostenlos und werbefinanziert.
        <br />
        Optional bieten wir eine werbefreie Premium-Version an, welche zusätzliche Funktionen und Inhalte anbietet.
      </div>
    ),
  },
  {
    question: 'Allgemeines',
    answer: (
      <div>
        Schlaukopf.de erbringt Leistungen nur auf Grundlage dieser Vertragsbedingungen.
        <br />
        Schlaukopf.de bietet die Möglichkeit, online zu lernen und das gelernte Wissen abzufragen.
      </div>
    ),
  },
  {
    question: 'Kostenlose Leistungen',
    answer: (
      <div>
        Das Angebot bei schlaukopf.de ist grundsätzlich kostenlos. Die kostenlose Mitgliedschaft beginnt mit dem Tag der Registrierung und
        wird auf unbestimmte Zeit geschlossen. Beide Parteien können die kostenlose Mitgliedschaft jederzeit ohne Angabe von Gründen
        beenden. Aufgrund der Beschaffenheit des Internets gewährleistet Schlaukopf.de nicht, dass die Webseiten ununterbrochen zur
        Verfügung stehen. Bezüglich der Dauer einer Unterbrechungszeit sowie einer angemessenen Vor- und Nachlaufzeit ist Schlaukopf.de von
        der Verpflichtung zur Übermittlung der Web-Seiten befreit.
      </div>
    ),
  },
  {
    question: 'Registrierung',
    answer: (
      <div>
        Der Nutzer ist verpflichtet, bei der Registrierung seine eigene, valide E-Mailadresse anzugeben und diese auf dem aktuellen Stand zu
        halten. Werden unvollständige oder falsche Angaben gemacht, so ist Schlaukopf.de berechtigt, den Nutzer nach pflichtgemäßem Ermessen
        vorübergehend zu sperren oder auszuschließen. Mehrfachregistrierungen mit unterschiedlichen Benutzernamen sind erlaubt.
      </div>
    ),
  },
  {
    question: 'Passwort, Sicherheit',
    answer: (
      <div>
        Jedes Mitglied wählt einen Benutzernamen und erhält ein Passwort. Es liegt in der Verantwortung des Mitglieds, die Vertraulichkeit
        des Benutzernamens und des Passwortes zu schützen. Das Mitglied ist für alle Aktivitäten verantwortlich, die unter seinem
        Benutzernamen und seinem Passwort durchgeführt werden.
      </div>
    ),
  },
  {
    question: 'Haftungsausschluss',
    answer: (
      <div>
        Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte
        können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten
        nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet,
        übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
        Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen
        bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten
        Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
      </div>
    ),
  },
  {
    question: 'Haftung für Links',
    answer: (
      <div>
        Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese
        fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber
        der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft.
        Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten
        Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden
        wir derartige Links umgehend entfernen.
      </div>
    ),
  },
  {
    question: 'Urheberrecht',
    answer: (
      <div>
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die
        Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
        schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht
        kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte
        Dritter beachtet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden
        Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
      </div>
    ),
  },
  {
    question: 'Datenschutz',
    answer: (
      <div>
        <p>
          Die Nutzung unserer Webseite ist in der Regel ohne Angabe personenbezogener Daten möglich. Soweit auf unseren Seiten
          personenbezogene Daten (beispielsweise Name, Anschrift oder E-Mail-Adressen) erhoben werden, erfolgt dies, soweit möglich, stets
          auf freiwilliger Basis. Diese Daten werden ohne Ihre ausdrückliche Zustimmung nicht an Dritte weitergegeben.
        </p>
        <p>
          Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen
          kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.{' '}
        </p>
        <p>
          Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten durch Dritte zur Übersendung von nicht ausdrücklich
          angeforderter Werbung und Informationsmaterialien wird hiermit ausdrücklich widersprochen. Die Betreiber der Seiten behalten sich
          ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung von Werbeinformationen, etwa durch Spam-Mails, vor.
        </p>
      </div>
    ),
  },
];

const datenschutz = [
  {
    question: 'Datenverarbeitung auf dieser Internetseite',
    answer: (
      <div>
        <p>
          Schlaukopf.de erhebt und speichert automatisch Informationen, die Ihr Browser an uns übermittelt. Dies sind:
          <br />
          * Browsertyp und Browserversion
          <br />
          * verwendetes Betriebssystem
          <br />
          * Referrer URL (die zuvor besuchte Seite)
          <br />
          * Hostname des zugreifenden Rechners (IP Adresse)
          <br />
          * Uhrzeit der Serveranfrage.
          <br />
        </p>
        <p>
          Darüber hinaus speichern wir folgende Informationen, um ein optimales Lernerlebnis zu ermöglichen:
          <br />
          * Ihre E-Mailadresse, falls Sie diese angeben.
          <br />
          * Welche Fragen von ihnen beantwortet wurden.
          <br />
          * Wie gut die Fragen beantwortet wurden.
          <br />
          * Wann die Fragen beantwortet wurden.
          <br />
          * Welche Schulart und Klassenstufe Sie besuchen bzw. ihr Kind besucht. * In welchem Bundesland bzw. welcher Stadt Sie wohnen.
          <br />
          Mit der Nutzung von Schlaukopf.de erklären Sie sich mit der Speicherung von diesen Daten einverstanden.
        </p>
        <p>
          Diese Daten sind für Schlaukopf.de nicht zwingend bestimmten Personen zuordenbar.
          <br />
          Die Angabe einer E-Mailadresse ist freiwillig.
          <br />
          Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen.
          <br />
          Alle ihre Daten werden spätestens nach 365 Tagen Inaktivität gelöscht.
        </p>
      </div>
    ),
  },
  {
    question: 'Cookies',
    answer: (
      <div>
        Die Internetseiten verwenden an mehreren Stellen so genannte Cookies. Diese dienen dazu, unser Angebot nutzerfreundlicher,
        effektiver und sicherer zu machen. Cookies sind kleine Textdateien, die auf Ihrem Rechner abgelegt werden und die Ihr Browser
        speichert. Dank den Cookies müssen Sie sich bei einem erneuten Besuch von Schlaukopf.de nicht jedes Mal erneut einloggen. Cookies
        richten auf Ihrem Rechner keinen Schaden an und enthalten keine Viren.
      </div>
    ),
  },
  {
    question: 'E-Mails - Lernergebnis-Diagramme und Newsletter',
    answer: (
      <div>
        Wenn Sie am Folgetag des Lernens Statisik-Diagramme oder den monatlichen Lernreport Newsletter per E-Mail empfangen möchten,
        benötigen wir von Ihnen eine valide Email-Adresse sowie Informationen, die uns die Überprüfung gestatten, dass Sie der Inhaber der
        angegebenen Email-Adresse sind bzw. deren Inhaber mit dem Empfang des Newsletters einverstanden ist. Weitere Daten werden nicht
        erhoben. Ihre Einwilligung zur Speicherung der Daten, der E-Mail-Adresse sowie deren Nutzung zum Versand des Newsletters können Sie
        jederzeit widerrufen, indem Sie ganz unten in der E-Mail auf den Abmelden-Link klicken.
      </div>
    ),
  },
 /* {
    question: 'Google Analytics',
    answer: (
      <div>
        Diese Website benutzt Google Analytics, einen Webanalysedienst der Google Inc. („Google“) Google Analytics verwendet sog. „Cookies“,
        Textdateien, die auf Ihrem Computer gespeichert werden und die eine Analyse der Benutzung der Website durch Sie ermöglicht. Die
        durch den Cookie erzeugten Informationen über Ihre Benutzung diese Website (einschließlich Ihrer IP-Adresse) wird an einen Server
        von Google in den USA übertragen und dort gespeichert. Google wird diese Informationen benutzen, um Ihre Nutzung der Website
        auszuwerten, um Reports über die Websiteaktivitäten für die Websitebetreiber zusammenzustellen und um weitere mit der Websitenutzung
        und der Internetnutzung verbundene Dienstleistungen zu erbringen. Auch wird Google diese Informationen gegebenenfalls an Dritte
        übertragen, sofern dies gesetzlich vorgeschrieben oder soweit Dritte diese Daten im Auftrag von Google verarbeiten. Google wird in
        keinem Fall Ihre IP-Adresse mit anderen Daten der Google in Verbindung bringen. Sie können die Installation der Cookies durch eine
        entsprechende Einstellung Ihrer Browser Software verhindern; wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall
        gegebenenfalls nicht sämtliche Funktionen dieser Website voll umfänglich nutzen können. Durch die Nutzung dieser Website erklären
        Sie sich mit der Bearbeitung der über Sie erhobenen Daten durch Google in der zuvor beschriebenen Art und Weise und zu dem zuvor
        benannten Zweck einverstanden.
      </div>
    ),
  }, */
  {
    question: <span>Google Adsense <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
        Entfällt bei Premium Version
      </span></span>,
    answer: (
      <div>
        <p>
          Auf dieser Web-Seite sind Werbe-Anzeigen geschaltet. Diese sind für eine nachhaltige Finanzierung der Plattform notwendig. Sie
          können die Werbebanner entfernen, indem Sie einen so genannten Adblocker installieren oder die Premium Version buchen. Da diese
          Web-Seite sich an Jugendliche richtet, haben wir alle sensiblen Anzeigekategorien blockiert. Sollte ihnen dennoch unpassende
          Werbung auffallen, so bitten wir um umgehende Nachricht.
        </p>
        <p>
          Für die Schaltung der Werbebanner verwendet diese Website Google AdSense. Dies ist ein Dienst der Google Inc., 1600 Amphitheatre
          Parkway, Mountain View, CA 94043, USA, mit dem Werbeanzeigen auf Internetseiten eingebunden werden können. Google AdSense
          verwendet eigene Cookies. Durch die Speicherung der Cookies auf Ihrem Computer kann Google Ihre Benutzung dieser Internetseite
          analysieren. Bei Google AdSense werden zudem auch sogenannte Web Beacons verwendet. Das sind nicht sichtbare Grafiken. Damit kann
          Google Informationen, wie zum Beispiel die Klicks auf diese Internetseite oder den Verkehr auf dieser, analysieren.
        </p>
        <p>
          Die genannten Informationen, Ihre IP-Adresse und die Auslieferung von Werbeformaten werden an die Google-Server in den USA
          übermittelt und von diesen gespeichert. Diese gesamten Informationen wird Google möglicherweise an Dritte weitergeben, wenn dies
          von Gesetzes wegen gefordert ist oder für den Fall, dass Dritte von Google beauftragt werden, diese Datenverarbeitung vorzunehmen.
          Google wird Ihre IP-Adresse jedoch nicht mit anderen von Ihnen gespeicherten Daten zusammenführen.
        </p>
        <p>
          Sie haben die Möglichkeit, zu verhindern, dass die genannten Cookies auf Ihrem Computer gespeichert werden. Dazu müssen Sie an
          Ihrem Internetbrowser eine dementsprechende Einstellung vornehmen. Allerdings besteht dann die Möglichkeit, dass diese
          Internetseite für Sie nur eingeschränkt nutzbar ist. Durch die Nutzung der Website erklären Sie sich mit der Bearbeitung der über
          Sie erhobenen Daten durch Google in der zuvor beschriebenen Art und Weise und zu dem zuvor benannten Zweck einverstanden.
        </p>
      </div>
    ),
  },
  {
    question: <span>OpenX <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
        Entfällt bei Premium Version
      </span></span>,
    answer: (
      <div>
        Unsere Website benutzt OpenX, einen Dienst der Firma OpenX GmbH, Maximilianstrasse 47, 80538 München, Germany. OpenX verwendet unter
        anderem Cookies, die auf Ihrem Computer gespeichert werden und die eine Analyse der Benutzung der Website ermöglicht. Im Rahmen der
        Benutzung können Daten, wie insbesondere die IP-Adresse und Aktivitäten der Nutzer an einen Server der Firma OpenX GmbH übermittelt
        und dort gespeichert werden. Wir nutzen diese Daten, um die volle Funktionalität unserer Webseite zu gewährleisten. Die OpenX GmbH
        wird diese Informationen gegebenenfalls an Dritte übertragen, sofern dies gesetzlich vorgeschrieben ist oder soweit eine
        Verarbeitung dieser Daten durch Dritte stattfindet. Rechtsgrundlage für die Datenverarbeitung ist Art. 6 Abs.1 lit. f DSGVO. Das
        berechtigte Interesse besteht in einer fehlerfreien Funktion der Internetseite. OpenX hat sich im Rahmen des
        EU-US-Privacy-Shield-Abkommens selbst zertifiziert (vgl. https://www.privacyshield.gov/list). Die Löschung der Daten erfolgt, sobald
        der Zweck ihrer Erhebung erfüllt wurde. Weitere Informationen zum Handling der übertragenen Daten finden Sie in der
        Datenschutzerklärung von OpenX: https://www.openx.com/legal/privacy-policy/. Sie können die Erfassung und Weiterleitung
        personenbezogenen Daten (insb. Ihrer IP-Adresse) sowie die Verarbeitung dieser Daten verhindern, indem sie die Ausführung von
        Java-Script in Ihrem Browser deaktivieren oder einen Script-Blocker in Ihrem Browser installieren (diesen finden Sie z.B. unter
        https://noscript.net/ oder https://www.ghostery.com/). Eine zusätzliche Opt-Out-Option steht unter dem nachfolgenden Link zum Abruf
        bereit: http://www.youronlinechoices.com/de/praferenzmanagement/.
      </div>
    ),
  },
  {
    question: <span>Rubicon <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
        Entfällt bei Premium Version
      </span></span>,
    answer: (
      <div>
        Rubicon Project (https://www.rubiconproject.com) setzt Technologien ein, um Ihnen für Sie relevante Werbeanzeigen zu präsentieren.
        Anbieter von Rubicon Project ist Rubicon Project, inc. mit Sitz in Playa Vista – 12181 Bluff Creek Drive, 4th Floor, Playa Vista, CA
        90094, USA. Wenn Sie nicht wollen, dass weiterhin anonymisierte Daten von Rubicon Project gesammelt werden, klicken Sie bitte auf
        diesen Opt-out Link: https://rubiconproject.com/privacy/consumer-online-profile-and-opt-out/. Dieses OptOut-Cookie löscht die bisher
        gespeicherten Informationen und verhindert ein weiteres Erfassen von Informationen. Weitere Datenschutzerklärungen finden Sie hier:
        https://rubiconproject.com/privacy-policy/.
      </div>
    ),
  },
  {
    question: <span>Criteo <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
        Entfällt bei Premium Version
      </span></span>,
    answer: (
      <div>
        Criteo (https://www.criteo.com) setzt Technologien ein, um Ihnen für Sie relevante Werbeanzeigen zu präsentieren. Anbieter von
        Criteo ist Criteo mit Sitz in Paris – 32 Rue Blanche, 75009 Paris, France. Wenn Sie nicht wollen, dass weiterhin anonymisierte Daten
        von Criteo gesammelt werden, klicken Sie bitte HIER auf den Opt-out Link: https://www.criteo.com/privacy/. Dieses OptOut-Cookie
        löscht die bisher gespeicherten Informationen und verhindert ein weiteres Erfassen von Informationen. Weitere Informationen zu den
        Datenschutzbestimmungen von Criteo finden Sie hier: https://www.criteo.com/privacy/
      </div>
    ),
  },
  {
    question: <span>Index Exchange <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
        Entfällt bei Premium Version
      </span></span>,
    answer: (
      <div>
        Indexexchange (http://www.indexexchange.com/) setzt Technologien ein, um Ihnen für Sie relevante Werbeanzeigen zu präsentieren.
        Anbieter von Indexexchange ist Indexexchange mit Sitz in New York: 20 W 22nd St. Suite 1101, New York, NY 10010. Wenn Sie nicht
        wollen, dass weiterhin anonymisierte Daten von Indexexchange gesammelt werden, klicken Sie bitte hier auf den Opt-out Link:
        http://optout.networkadvertising.org/?c=1#!/. Dieses OptOut-Cookie löscht die bisher gespeicherten Informationen und verhindert ein
        weiteres Erfassen von Informationen. Weitere Informationen zu den Datenschutzbestimmungen von IndexExchange finden Sie hier:
        http://www.indexexchange.com/privacy/.
      </div>
    ),
  },
  {
    question: <span>AppNexus <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
        Entfällt bei Premium Version
      </span></span>,
    answer: (
      <div>
        AppNexus (https://www.appnexus.com) setzt Technologien ein, um Ihnen für Sie relevante Werbeanzeigen zu präsentieren. Anbieter von
        AppNexus ist die AppNexus Group mit Sitz in New York: 28 W. 23rd Street, New York, NY 10010. Wenn Sie nicht wollen, dass weiterhin
        anonymisierte Daten von Appnexus gesammelt werden, klicken Sie bitte hier auf den Opt-out Link:
        https://www.appnexus.com/en/company/platform-privacy-policy#choices. Dieses OptOut-Cookie löscht die bisher gespeicherten
        Informationen und verhindert ein weiteres Erfassen von Informationen. Weitere Informationen zu den Datenschutzbestimmungen von
        AppNexus finden Sie hier: https://www.appnexus.com/en/company/privacy-policy
      </div>
    ),
  },
  {
    question: <span>Pubmatic <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
        Entfällt bei Premium Version
      </span></span>,
    answer: (
      <div>
        Pubmatic (https://www.pubmatic.com) setzt Technologien ein, um Ihnen für Sie relevante Werbeanzeigen zu präsentieren. Anbieter von
        Pubmatic ist Pubmatic, Inc. mit Sitz in Redwood City – 305 Main Street, First Floor, Redwood City, California 94063, USA. Wenn Sie
        nicht wollen, dass weiterhin anonymisierte Daten von Pubmatic gesammelt werden, klicken Sie bitte unten auf diesen Opt-out Link:
        https://pubmatic.com/legal/opt-out/. Dieses OptOut-Cookie löscht die bisher gespeicherten Informationen und verhindert ein weiteres
        Erfassen von Informationen. Weitere Informationen zu den Datenschutzbestimmungen von Pubmatic finden Sie hier:
        https://pubmatic.com/legal/privacy-policy/.
      </div>
    ),
  },
  {
    question: <span>Yieldlab <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
        Entfällt bei Premium Version
      </span></span>,
    answer: (
      <div>
        Die Yieldlab AG, Colonnaden 41, 20354 Hamburg setzt auf unserer Website Cookies ein, um die Einblendung von Werbemitteln, die durch
        uns geschaltet werden, für den User auszusteuern und zu optimieren. Dies betrifft zum Beispiel die maximale Anzeigehäufigkeit von
        Werbemitteln, die Sie zu sehen bekommen. Zudem nutzt Yieldlab in Einzelfällen gespeicherte Cookie-Informationen für statistische
        Erhebungen. Yieldlab speichert durch das Setzen von Cookies keine personenbezogenen Daten wie Name, Email-Adressen oder andere
        persönliche Angaben. Alle Informationen sind pseudonym und enthalten technische Informationen wie beispielsweise die
        Anzeigenhäufigkeit und das Anzeigedatum von Werbemitteln, den benutzten Browser oder auch das installierte Betriebssystem. Die
        Nutzung der Dienste von Yieldlab dient der Wahrung unserer im Rahmen einer Interessensabwägung überwiegenden berechtigten Interessen
        an einer optimalen Vermarktung unserer Website gemäß Art. 6 Abs. 1 S. 1 lit. f DSGVO. Yieldlab arbeitet in sämtlichen Prozessen der
        Datenerfassung streng konform nach dem europäischen und deutschen Datenschutzrecht. Die Daten werden nur in den Mitgliedstaaten der
        Europäischen Union verarbeitet. Insbesondere befinden sich die vom Yieldlab zur Datenverarbeitung genutzten Internet-Server in den
        Mitgliedstaaten der EU. Eine Übermittlung an ein Drittland oder eine internationale Organisation erfolgt grundsätzlich nicht. Um der
        Datenerhebung durch Yieldlab zu widersprechen, können Sie über den nachfolgenden Link ein Opt-Out-Cookie beziehen:
        https://www.yieldlab.de/elements/privacy/. Dieser Opt-Out gilt nur für das jeweils von Ihnen genutzte Gerät und verliert zudem seine
        Gültigkeit, wenn Sie Ihre Cookies löschen. Weitere Informationen und die geltenden Datenschutzbestimmungen der Yieldlab AG können
        unter https://www.yieldlab.de/meta-navigation/datenschutzerklaerung/ abgerufen werden.
      </div>
    ),
  },
  {
    question: <span>Sentry <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
        Entfällt bei Premium Version
      </span></span>,
    answer: (
      <div>
        Wir verwenden den Dienst Sentry (Sentry, 1501 Mariposa St #408, San Francisco, CA 94107, USA), um die technische Stabilität unseres
        Dienstes durch Überwachung der Systemstabilität und Ermittlung von Codefehlern zu verbessern. Sentry dient alleine diesen Zielen und
        wertet keine Daten zu Werbezwecken aus. Die Daten der Nutzer, wie z.B. Angaben zum Gerät oder Fehlerzeitpunkt werden anonym erhoben
        und nicht personenbezogen genutzt sowie anschließend gelöscht. Weitere Informationen hierzu finden Sie in der Datenschutzerklärung
        von Sentry: https://sentry.io/privacy/ .
      </div>
    ),
  },
  {
    question: 'VG WORT',
    answer: (
      <div>
        <p>
          Cookies und Meldungen zu Zugriffszahlen Wir setzen „Session-Cookies“ der VG Wort, München, zur Messung von Zugriffen auf Texten
          ein, um die Kopierwahrscheinlichkeit zu erfassen. Session-Cookies sind kleine Informationseinheiten, die ein Anbieter im
          Arbeitsspeicher des Computers des Besuchers speichert. In einem Session-Cookie wird eine zufällig erzeugte eindeutige
          Identifikationsnummer abgelegt, eine sogenannte Session-ID. Außerdem enthält ein Cookie die Angabe über seine Herkunft und die
          Speicherfrist. Session-Cookies können keine anderen Daten speichern. Diese Messungen werden von der Kantar Germany GmbH nach dem
          Skalierbaren Zentralen Messverfahren (SZM) durchgeführt. Sie helfen dabei, die Kopierwahrscheinlichkeit einzelner Texte zur
          Vergütung von gesetzlichen Ansprüchen von Autoren und Verlagen zu ermitteln. Wir erfassen keine personenbezogenen Daten über
          Cookies. Viele unserer Seiten sind mit JavaScript-Aufrufen versehen, über die wir die Zugriffe an die Verwertungsgesellschaft Wort
          (VG Wort) melden. Wir ermöglichen damit, dass unsere Autoren an den Ausschüttungen der VG Wort partizipieren, die die gesetzliche
          Vergütung für die Nutzungen urheberrechtlich geschützter Werke gem. § 53 UrhG sicherstellen. Eine Nutzung unserer Angebote ist
          auch ohne Cookies möglich. Die meisten Browser sind so eingestellt, dass sie Cookies automatisch akzeptieren. Sie können das
          Speichern von Cookies jedoch deaktivieren oder Ihren Browser so einstellen, dass er Sie benachrichtigt, sobald Cookies gesendet
          werden.
        </p>
        <h5>Datenschutzerklärung zur Nutzung des Skalierbaren Zentralen Messverfahrens</h5>
        <p>
          Unsere Website und unser mobiles Webangebot nutzen das „Skalierbare Zentrale Messverfahren“ (SZM) der Kantar Germany GmbH für die
          Ermittlung statistischer Kennwerte zur Ermittlung der Kopierwahrscheinlichkeit von Texten. Dabei werden anonyme Messwerte erhoben.
          Die Zugriffszahlenmessung verwendet zur Wiedererkennung von Computersystemen alternativ ein Session-Cookie oder eine Signatur, die
          aus verschiedenen automatisch übertragenen Informationen Ihres Browsers erstellt wird. IP-Adressen werden nur in anonymisierter
          Form verarbeitet. Das Verfahren wurde unter der Beachtung des Datenschutzes entwickelt. Einziges Ziel des Verfahrens ist es, die
          Kopierwahrscheinlichkeit einzelner Texte zu ermitteln. Zu keinem Zeitpunkt werden einzelne Nutzer identifiziert. Ihre Identität
          bleibt immer geschützt. Sie erhalten über das System keine Werbung.
        </p>
      </div>
    ),
  },
  {
    question: 'Auskunftsrecht',
    answer: (
      <div>
        Sie haben jederzeit das Recht auf Auskunft über die bezüglich Ihrer Person gespeicherten Daten, deren Herkunft und Empfänger sowie
        den Zweck der Speicherung. Auskunft über die gespeicherten Daten erhalten Sie unter der bei Kontakt angegebenen E-Mailadresse.
      </div>
    ),
  },
  {
    question: 'Schlaukopf Android und iOS App',
    answer: (
      <p>
        Für die mobilen Schlaukopf Apps gelten die folgenden Bestimmungen:
        <br />
        <a href="http://appsistance.de/schlaukopf/terms-of-use-ios/" target="_blank">
          Nutzungs- und Datenschutzbedingungen für Schlaukopf iOS App
        </a>
        <br />
        <a href="http://appsistance.de/schlaukopf/nutzungsbedingungen-datenschutz-android/" target="_blank">
          Nutzungs- und Datenschutzbedingungen für Schlaukopf Android App
        </a>
      </p>
    ),
  },
  {
    question: 'Weitere Informationen',
    answer: (
      <div>
        Ihr Vertrauen ist uns wichtig. Daher möchten wir Ihnen jederzeit Rede und Antwort bezüglich der Verarbeitung Ihrer personenbezogenen
        Daten stehen. Wenn Sie Fragen haben, die Ihnen diese Datenschutzerklärung nicht beantworten konnte oder wenn Sie zu einem Punkt
        vertiefte Informationen wünschen, wenden Sie sich bitte jederzeit an uns.
      </div>
    ),
  },
  // More questions...
];

@observer
class InfoImpressum extends React.Component<ServerProps<typeof getServerSideProps>> {
  constructor(props) {
    super(props);
    // makeObservable(this);
  }

  @memoize
  get store() {
    return Store.forApp(this);
  }

  setupPage(store: Store) {
    store.portalStore.metaTitle = 'Schlaukopf Impressum';
  }

  render() {
    const { userData } = this.props;

    return (
      <StoreContext.Provider value={this.store}>
        <Head>
          <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
          <title>Schlaukopf - Datenschutz und AGBs</title>
          <meta name="Description" content="Datenschutz und AGB der Lernplattform Schlaukopf." />
          <meta name="Keywords" content="Schlaukopf,Datenschutz,AGB" />
          <meta name="Language" content="de" />
          <meta name="robots" content="index,follow" />
        </Head>
        <div className="antialiased font-sans  bg-gray-50" style={{ minHeight: '100vh' }}>
          <InfoTopbar />
          <div>
            <main>
              <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                {/* Replace with your content */}
                <div className="relative bg-white">
                  <div className="absolute inset-0">
                    <div className="absolute inset-y-0 left-0 w-1/2 bg-gray-50" />
                  </div>
                  <div className="relative max-w-7xl mx-auto lg:grid lg:grid-cols-5">
                    <div className="bg-gray-50 py-16 px-4 sm:px-6 lg:col-span-2 lg:px-8 lg:py-24 xl:pr-12">
                      <div className="max-w-lg mx-auto">
                        <h2 className="text-2xl font-extrabold tracking-tight text-gray-900 sm:text-3xl">Kontakt</h2>
                        <p className="mt-3 text-lg leading-6 text-gray-500">
                          Anbieter dieser Web-Seite und verantwortlich nach § 5 TMG.
                        </p>
                        <dl className="mt-8 text-base text-gray-500">
                          <div>
                            <dt className="sr-only">Anschrift</dt>
                            <dd>
                              <p>Digitalwerk eG</p>
                              <p>Bachstr. 6</p>
                              <p>72810 Gomaringen</p>
                            </dd>
                          </div>
                          <div className="mt-6">
                            <dt className="sr-only">Telefon</dt>
                            <dd className="flex">
                              <PhoneIcon className="flex-shrink-0 h-6 w-6 text-gray-400" aria-hidden="true" />
                              <span className="ml-3">+49 (07072) 2650</span>
                            </dd>
                          </div>
                          <div className="mt-3">
                            <dt className="sr-only">Email</dt>
                            <dd className="flex">
                              <MailIcon className="flex-shrink-0 h-6 w-6 text-gray-400" aria-hidden="true" />
                              <span className="ml-3">email@schlaukopf.de</span>
                            </dd>
                          </div>
                        </dl>
                        <p className="mt-6 text-base text-gray-500">SteuerID: DE 229865557</p>
                      </div>
                    </div>
                    <div className="bg-white py-16 px-4 sm:px-6 lg:col-span-3 lg:py-24 lg:px-8 xl:pl-12">
                      <div className="max-w-lg mx-auto lg:max-w-none">
                        {/* Begin WHITE BLOCK */}

                        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                          <div className="relative">
                            <blockquote className="mt-10">
                              <div className="max-w-3xl mx-auto text-center text-2xl leading-9 font-medium text-gray-900">
                                <p>Ihre Daten sind bei uns sicher.</p>
                              </div>

                              <div className="mt-10 max-w-3xl mx-auto text-center text-2xl leading-9 font-medium text-gray-900">
                                <p>Schlaukopf ist kostenlos nutzbar.</p>
                              </div>

                              <div className="mt-10 max-w-3xl mx-auto text-center text-2xl leading-9 font-medium text-gray-900">
                                <p>Schlaukopf Premium ist ein optionales Upgrade.</p>
                              </div>
                            </blockquote>
                          </div>
                        </div>

                        {/* End WHITE BLOCK */}
                      </div>
                    </div>
                  </div>
                </div>
                {/* /End replace */}
              </div>
              <div className="bg-white">
                <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:py-20 lg:px-8">
                  <div className="lg:grid lg:grid-cols-3 lg:gap-8">
                    <div>
                      <h2 className="text-3xl font-extrabold text-gray-900">Allgemeine Geschäftsbedingungen</h2>
                      <p className="mt-4 text-lg text-gray-500">
                        Wir möchten ein fair und transparent sein. Gleichzeitig erwarten wir von unseren Nutzern, dass sie wahrheitsgemäße
                        Angaben machen und das Angebot nicht mißbräuchlich verwenden.
                      </p>
                    </div>
                    <div className="mt-12 lg:mt-0 lg:col-span-2">
                      <dl className="space-y-12">
                        {agbs.map((agb, index) => (
                          <div key={index}>
                            <dt className="text-lg leading-6 font-medium text-gray-900">{agb.question}</dt>
                            <dd className="mt-2 text-base text-gray-500">{agb.answer}</dd>
                          </div>
                        ))}
                      </dl>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-white">
                <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:py-20 lg:px-8">
                  <div className="lg:grid lg:grid-cols-3 lg:gap-8">
                    <div>
                      <h2 className="text-3xl font-extrabold text-gray-900">Datenschutz</h2>
                      <p className="mt-4 text-lg text-gray-500">
                        Wir, die Mitwirkenden bei Schlaukopf.de, nehmen den Schutz Ihrer persönlichen Daten sehr ernst und halten uns strikt
                        an die Regeln der Datenschutzgesetze. Personenbezogene Daten werden auf dieser Webseite nur im technisch notwendigen
                        Umfang erhoben. In keinem Fall werden die erhobenen Daten verkauft oder aus anderen Gründen an Dritte weitergegeben.
                        Die nachfolgende Erklärung gibt Ihnen einen Überblick darüber, wie wir diesen Schutz gewährleisten und welche Art
                        von Daten zu welchem Zweck erhoben werden.
                      </p>
                    </div>
                    <div className="mt-12 lg:mt-0 lg:col-span-2">
                      <dl className="space-y-12">
                        {datenschutz.map(faq => (
                          <div key={faq.question}>
                            <dt className="text-lg leading-6 font-medium text-gray-900">{faq.question}</dt>
                            <dd className="mt-2 text-base text-gray-500">{faq.answer}</dd>
                          </div>
                        ))}
                      </dl>
                    </div>
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>
      </StoreContext.Provider>
    );
  }
}

export default InfoImpressum;
